import { getFileContent } from '../../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../../helpers/browseAPIhandler';
import { regenTokenifExpired } from '../../../helpers/utilityFunctions';
import { v4 as uuidv4 } from 'uuid';
import { useStore } from '../../../core/useStore';
import { getImageAsBase64 } from '../../../helpers/fetchDatafromContentSVC';
const { regenTokenandBrowse } = browseAPIhandler();
let integratedSolutionsPromise = null;
//get docs home details from the contents repo
const getIntegratedSolutionsContents = (url, fileName) => {
  const IntegratedSoldata = getFileContent(
    `${url}?resourcePath=pages/integrated-solutions&resourceName=${fileName}`,
    regenTokenandBrowse,
  );
  // console.log(IntegratedSoldata, "IntegratedSoldata")
  return IntegratedSoldata;
};

const fetchIntegratedSolutionsConfig = async (contenturl) => {
  const token = await regenTokenifExpired();

  const response = await fetch(
    `${contenturl}?resourcePath=pages/integrated-solutions&resourceName=config.json`,
    {
      headers: {
        Authorization: token,
        uuid: uuidv4(),
        audience: 'public',
      },
      credentials: 'omit',
    },
  );

  if (!response.ok) {
    const error = new Error(response.statusText);
    error.statusCode = response.status;
    throw error;
  }

  return await response.json();
};
const getImageMimeType = (fileName) => {
  const ext = fileName?.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'svg':
      return 'image/svg+xml';
    case 'png':
      return 'image/png';
    case 'webp':
      return 'image/webp';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    default:
      return 'image/svg+xml';
  }
};
const FetchMdDetail = async (url, fileName, dataTestId) => {
  // const token = localStorage.getItem('token');
  const token = await regenTokenifExpired();
  return await fetch(
    `${url}?resourcePath=pages/integrated-solutions/details&resourceName=${fileName}.md`,
    {
      headers: {
        Authorization: token,
        uuid: uuidv4(),
        audience: 'public',
      },
      credentials: 'omit',
    },
  ).then((x) => {
    if (!x?.ok) {
      let error = new Error(x?.statusText);
      error.statusCode = x?.status || x?.code;
      throw error;
    }
    return dataTestId ? x.response : x.text();
  });
};
const processMarkdown = (data) => {
  let content = data || '';
  const bannerMatch = content.match(/<PageBanner[\s\S]*?<\/PageBanner>/);
  const banner = bannerMatch?.[0] || '';
  if (bannerMatch) {
    content = content.replace(bannerMatch[0], '');
  }
  const h1Match = content.match(/^#\s+(.*)$/m);
  const title = h1Match?.[1] || '';
  if (h1Match) {
    content = content.replace(h1Match[0], '');
  }
  content = content.replace(/^(\s*---\s*)+/, '');
  return {
    banner,
    title,
    content: content.trim(),
  };
};
const getIntegratedSolutionBannerLogo = async (contenturl, logo, isDetailsResource = false) => {
  const resourcePath = isDetailsResource
    ? 'pages/integrated-solutions/details/resources'
    : 'pages/integrated-solutions/logos';

  const imageUrl = `${contenturl}?resourcePath=${resourcePath}&resourceName=${logo}`;

  return imageUrl;
};

const preLoadIntegratedSolutionsData = async (contenturl = '/api-portal-content/portal-content') => {
  const storeState = useStore.getState().integratedSolData;
  // Already loaded
  if (storeState?.cardsConfig?.sections?.length > 0) {
    return storeState.cardsConfig;
  }
  // Request already running
  if (integratedSolutionsPromise) {
    return integratedSolutionsPromise;
  }

  integratedSolutionsPromise = (async () => {
    try {
      useStore.setState({
        integratedSolData: {
          ...useStore.getState().integratedSolData,
          loading: true,
          error: null,
        },
      });

      const config = await fetchIntegratedSolutionsConfig(contenturl);
      const sections = config?.sections || [];
      const uniqueSectionLogos = [
        ...new Set(sections.map((section) => section.logo).filter(Boolean)),
      ];
      const uniqueCardLogos = [
        ...new Set(
          sections
            .flatMap((section) => section.cards || [])
            .map((card) => card.logo)
            .filter(Boolean),
        ),
      ];
      const sectionLogoEntries = await Promise.all(
        uniqueSectionLogos.map(async (logo) => {
          const imageUrl =
            `${contenturl}?resourcePath=pages/integrated-solutions/logos` + `&resourceName=${logo}`;
          const base64 = await getImageAsBase64(imageUrl);
          return [logo, base64];
        }),
      );

      const cardLogoEntries = await Promise.all(
        uniqueCardLogos.map(async (logo) => {
          const imageUrl =
            `${contenturl}?resourcePath=pages/integrated-solutions/logos` + `&resourceName=${logo}`;
          const base64 = await getImageAsBase64(imageUrl);
          return [logo, base64];
        }),
      );

      useStore.setState({
        integratedSolData: {
          ...useStore.getState().integratedSolData,
          cardsConfig: config,
          sectionsLogoMap: Object.fromEntries(sectionLogoEntries),
          cardsLogoMap: Object.fromEntries(cardLogoEntries),
          loading: false,
          initialized: true,
          error: null,
        },
      });
      return config;
    } catch (error) {
      useStore.setState({
        integratedSolData: {
          ...useStore.getState().integratedSolData,
          loading: false,
          initialized: true,
          error: {
            statusCode: error?.statusCode || '',
            message: 'It happens sometimes, you may refresh the page or go to home.',
          },
        },
      });
      // throw error;
      console.log(error);
    } finally {
      integratedSolutionsPromise = null;
    }
  })();

  return integratedSolutionsPromise;
};

export {
  getIntegratedSolutionsContents,
  getImageMimeType,
  FetchMdDetail,
  getIntegratedSolutionBannerLogo,
  processMarkdown,
  preLoadIntegratedSolutionsData,
};
